const getId = (str) => str.split('/')[1].split('.')[0];

const goToCollectionRequirements = (
  idOfColl,
  collection,
  history,
  setComment,
  month,
  day,
  curYear
) => {
  const collAry = collection[idOfColl];
  const { type } = collAry.details;

  if (
    type === 'local'
    && collection[idOfColl].title.includes('Holiday')) {
    return setComment('holiday');
  }

  if (
    type === 'local'
    && collection[idOfColl].title.includes('Tree')) {
    return setComment('tree');
  }

  const collectionId = (
    collAry
    && collAry.details
    && collAry.details.path
  )
    ? getId(collAry.details.path)
    : null;

  if (type === 'remote'
    && collAry
    && collAry?.details
    && collAry?.details?.path?.includes('gpg')) {
    return history.push('/cal/general-page', { link: collAry.details.path, title: collAry.title });
  }

  const eventId = (
    collAry
    && collAry.details
    && collAry.details.path
    && collAry.details.path.includes('event')
  )
    ? getId(collAry.details.path)
    : null;
  if (
    type === 'remote'
    && eventId
  ) return history.push('/cal/event-list', { depoEventId: eventId, type: 'drop-event-list' });

  return history.push('/cal/collection-requirements', {
    id: collectionId, month, day, curYear
  });
};

export default goToCollectionRequirements;

export const extractWholeMonthEvents = (specificEvents) => {
  const wholeMonthObj = {};

  if (
    specificEvents
    && Object.keys(specificEvents)
  ) {
    Object.keys(specificEvents).map((item) => {
      const mutatedSpecificEvents = [...specificEvents[item].collections];
      const filtered = mutatedSpecificEvents.filter((event) => event.status !== 'is_none');

      if (filtered.length) wholeMonthObj[specificEvents[item].day] = filtered;

      return wholeMonthObj[specificEvents[item].day];
    });
  }
  return wholeMonthObj;
};
